// extracted by mini-css-extract-plugin
export default {"root":"BottomSection_root__0NLSq"};